import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-notice",
  "use": "icon-notice-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"icon-notice\">\n  <title>notice</title>\n  <path d=\"M8,0,0,14H16ZM8,2l6.28,11H1.72Zm-.79,8.42H8.84V12H7.21ZM8.85,5V6.84l-.36,3H7.57l-.37-3V5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/notice.svg
// module id = 152
// module chunks = 0 1 2